import { formatCurrency } from '@/common/utils/formatters'

interface ProposalGroupHeaderProps {
  title: string
  countDisplay: string
  totalValueSum: number
}

const ProposalGroupHeader = ({ title, countDisplay, totalValueSum }: ProposalGroupHeaderProps) => {
  return (
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <p className="font-bold text-sm">
        {title}
      </p>

      <div className="flex items-center gap-0.5 text-xs">
        <span>
          {countDisplay}
        </span>

        <span>
          •
        </span>

        <span className="text-valid">
          {formatCurrency(totalValueSum)}
        </span>
      </div>
    </div>
  )
}

export default ProposalGroupHeader
